import { ApiSysService } from "@services/api/api-sys.service";
import { AuthorizationError } from "../errors/auth-error";
import { BaseError } from "../errors/error-base";
import { ResourceError } from "../errors/resource-error";

/**
 * Add infrastructure to a network
 * @param {number} networkId The ID of the network
 * @param {number} infraId The ID of the infrastructure to be added
 * @param {string} token The token to be used in the request
 * @param {ApiSysService} apiSys The instance of the "apiSys" service
 * @param {any} translations The translations to be used in the error messages
 * @returns {Promise<any>} The response data
 */
export async function addInfrastructureToNetwork(
    networkId: number,
    infraId: number,
    token: string,
    apiSys: ApiSysService,
    translations: any
) {
    const { data, error } = await apiSys.addInfraToNetwork(token, networkId, infraId);
    
    if (error) {
        switch (error.status) {
            case 401:
                throw new AuthorizationError({
                    name: "PERSONNEL_NOT_AUTHORIZED",
                    message: translations?.error_401,
                    code: error.status,
                });
            case 500:
                throw new ResourceError({
                    name: "UPDATE_NETWORK_ERROR",
                    message: translations?.error_500,
                    cause: error,
                    code: error.status,
                });

            default:
                throw new BaseError({
                    name: "UNKNOWN_ERROR",
                    message: translations?.error_unk,
                    cause: error,
                    code: error.status,
                });
        }
    }
        
    return data;
}

/**
 * Remove infrastructure from a network
 * @param {number} networkId The ID of the network
 * @param {number} infraId The ID of the infrastructure to be removed
 * @param {string} token The token to be used in the request
 * @param {ApiSysService} apiSys The instance of the "apiSys" service
 * @param {any} translations The translations to be used in the error messages
 * @returns {Promise<any>} The response data
 */
export async function removeInfrastructureFromNetwork(
    networkId: number,
    infraId: number,
    token: string,
    apiSys: ApiSysService,
    translations: any
) {
    const { data, error } = await apiSys.rmInfraFromNetwork(token, networkId, infraId);
    
    if (error) {
        switch (error.status) {
            case 401:
                throw new AuthorizationError({
                    name: "PERSONNEL_NOT_AUTHORIZED",
                    message: translations?.error_401,
                    code: error.status,
                });
            case 500:
                throw new ResourceError({
                    name: "UPDATE_NETWORK_ERROR",
                    message: translations?.error_500,
                    cause: error,
                    code: error.status,
                });

            default:
                throw new BaseError({
                    name: "UNKNOWN_ERROR",
                    message: translations?.error_unk,
                    cause: error,
                    code: error.status,
                });
        }
    }
        
    return data;
}


/**
 * Remove infrastructure from a network
 * @param {number} networkId The ID of the network
 * @param {number} infraId The ID of the infrastructure to be removed
 * @param {string} token The token to be used in the request
 * @param {ApiSysService} apiSys The instance of the "apiSys" service
 * @param {any} translations The translations to be used in the error messages
 * @returns {Promise<any>} The response data
 */
export async function getNetworksUser(
    token: string,
    apiSys: ApiSysService,
    translations: any
) {
    const { data, error } = await apiSys.getNetworksUser(token);
    
    if (error) {
        switch (error.status) {
            case 401:
                throw new AuthorizationError({
                    name: "PERSONNEL_NOT_AUTHORIZED",
                    message: translations?.error_401,
                    code: error.status,
                });
            case 500:
                throw new ResourceError({
                    name: "UPDATE_NETWORK_ERROR",
                    message: translations?.error_500,
                    cause: error,
                    code: error.status,
                });

            default:
                throw new BaseError({
                    name: "UNKNOWN_ERROR",
                    message: translations?.error_unk,
                    cause: error,
                    code: error.status,
                });
        }
    }
        
    return data;
}